import React from 'react';
import { observer } from 'mobx-react';
import  './PurchaseAddressShow.less';

@observer
class PurchaseAddressShow extends  React.Component<any> {
    static defaultProps = {
        prefixCls: 'purchase-addShow'
    };

    render() {
        const {prefixCls, selectAddress, addList} = this.props;
        return (
            <div className={`${prefixCls} clearfix`} onClick={selectAddress}>
                <div className={`${prefixCls}-line`}/>
                <div className={`${prefixCls}-box`}>
                    <div className={`${prefixCls}-name-phone`}>
                        <span className={`${prefixCls}-name`}>{addList ? addList.contact : '-'}</span>
                        <span className={`${prefixCls}-phone`}>{addList && addList.mobilephone.replace(/(?=(\d{4})+$)/g, " ")}</span>
                    </div>
                    <div className={`${prefixCls}-address`}>
                        <span className={`${prefixCls}-location`}/>
                        <div>{addList ? ((addList.select[0].value ? addList.select[0].value : '') + '-' + (addList.select[1].value ? addList.select[1].value : '') + '-' + (addList.select[2].value ? addList.select[2].value : '')) : '-'} {addList ? addList.address : '-'}</div>
                    </div>
                </div>
                <span className={`${prefixCls}-more`}/>
            </div>
        )
    }
}

export default PurchaseAddressShow;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/giftComp/purchaseAddressShow/PurchaseAddressShow.tsx